import { defineAsyncComponent } from 'vue';

/**
 * Lazy-loaded CsLineChart component using defineAsyncComponent
 * This helps reduce initial bundle size by loading the chart component only when needed
 */
export const CsLineChart = defineAsyncComponent(() =>
  import('./CsLineChart.vue')
);
